import { Notifier } from './notifier';

export const notify = new Notifier();
